import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { suivreLePerimetre } from './api'
import { capturerInvitationInstallation, enregistrerServiceWorker } from './pwa/enregistrement'
import { creerRouteur } from './router'
import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import './styles.css'

const queryClient = new QueryClient()
// Une entité créée par l'autre administrateur : /moi relu dès qu'une liste la montre.
suivreLePerimetre(queryClient)
const routeur = creerRouteur(queryClient)

enregistrerServiceWorker()
capturerInvitationInstallation()
// Notification touchée alors que l'appli est ouverte : le service worker demande l'écran voulu.
navigator.serviceWorker?.addEventListener('message', (e: MessageEvent) => {
  const d = e.data as { type?: unknown; chemin?: unknown } | null
  if (d?.type === 'naviguer' && typeof d.chemin === 'string' && d.chemin.startsWith('/'))
    void routeur.navigate({ href: d.chemin })
})

// Lien ouvert alors que l'appli installée tourne déjà (ordinateur, Android ; manifeste,
// launch_handler « focus-existing ») : la fenêtre revient au premier plan et va à la page du lien.
type FileLancement = { setConsumer: (f: (p: { targetURL?: string }) => void) => void }
;(window as { launchQueue?: FileLancement }).launchQueue?.setConsumer(({ targetURL }) => {
  if (!targetURL) return
  const u = new URL(targetURL)
  const chemin = u.pathname + u.search + u.hash
  if (u.origin === window.location.origin && chemin !== routeur.state.location.href)
    void routeur.navigate({ href: chemin })
})

createRoot(document.getElementById('racine')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={routeur} />
    </QueryClientProvider>
  </StrictMode>,
)
